/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:f10a4172-1e0f-4086-8df3-8349749d137a",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_4z1qaJFj5",
    "aws_user_pools_web_client_id": "4st6aj61q4nml1e84b4967nkh3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://37l6jg6xxvesdbnqueartsv7he.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "stripeAPI",
            "endpoint": "https://vojlmvb4xi.execute-api.us-west-1.amazonaws.com/prod",
            "region": "us-west-1"
        },
        {
            "name": "appApi",
            "endpoint": "https://ink8scu4xi.execute-api.us-west-1.amazonaws.com/prod",
            "region": "us-west-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "gudusers-prod",
            "region": "us-west-1"
        }
    ]
};


export default awsmobile;
